import { withInstall } from '../../../utils/with-install'
import Marker from './Marker.vue'

export const ElAmapMarker = withInstall(Marker)
export default ElAmapMarker
